import { useEffect, useState, useRef, Suspense } from 'react';

import useMode from '../../stores/mode';
import useMarker from '../../stores/marker';
import markerData from '../../data/markers';

import { ARCanvas, ARMarker } from '../../react-three-arjs';

import { AdaptiveDpr } from '@react-three/drei';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

import Marker from './Marker';

import 'pepjs';
const ResizeObserver = window.ResizeObserver || Polyfill;

function Scene() {
    const mode = useMode();
    const marker = useMarker();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        marker.setId(null);
        marker.setVisible(false);
    }, []);

    function onChange(id) {
        if (!isReady) {
            return;
        }

        console.log('App.onChange()', id);

        marker.setId(id);
        marker.setVisible(id !== null);
    }

    return (
        <div className="AR-canvas">
            <ARCanvas
                flat={true}
                linear={false}
                dpr={Math.min(2, window.devicePixelRatio)}
                detectionMode={'mono_and_matrix'}
                onCreated={({ gl }) => {
                    console.log('onCreated()', gl);
                }}
                onCameraStreamReady={(arToolkitSource, arToolkitContext, gl) => {
                    console.log('onCameraStreamReady()', arToolkitSource, arToolkitContext, gl);
                }}
                onContextReady={(arToolkitSource, arToolkitContext, gl) => {
                    console.log('onContextReady()', arToolkitSource, arToolkitContext, gl);

                    setIsReady(true);
                }}
                shadows={true}
                resize={{
                    scroll: true,
                    debounce: {
                        scroll: 50,
                        resize: 0,
                    },
                    polyfill: typeof window === 'undefined' || !window.ResizeObserver ? Polyfill : undefined,
                }}
            >
                <Suspense fallback={null}>
                    <AdaptiveDpr></AdaptiveDpr>

                    <ambientLight intensity={0.75} />

                    <pointLight
                        position={[6, 6, 6]}
                        penumbra={0.5}
                        intensity={0.1}
                        castShadow
                        shadow-mapSize-width={2048}
                        shadow-mapSize-height={2048}
                    />

                    <spotLight position={[-4, 10, -2]} penumbra={0.5} intensity={0.25} color="#ffffff" />
                    <pointLight position={[4, 10, -2]} penumbra={0.5} intensity={0.25} color="#ffffff" />
                    {markerData.map((_marker) => (
                        <ARMarker
                            barcodeValue={_marker.barcodeValue}
                            onMarkerFound={() => {
                                if (!isReady) {
                                    return;
                                }

                                console.log(`Marker ${_marker.barcodeValue} found...`);
                                onChange(_marker.barcodeValue);
                            }}
                            onMarkerLost={() => {
                                if (!isReady) {
                                    return;
                                }

                                if (marker.id === _marker.barcodeValue) {
                                    console.log(`Marker ${_marker.barcodeValue} lost...`);
                                    onChange(null);
                                }
                            }}
                            key={_marker.barcodeValue}
                        >
                            <group>
                                {marker.visible && marker.id && marker.id === _marker.barcodeValue && (
                                    <Marker marker={_marker} />
                                )}
                            </group>
                        </ARMarker>
                    ))}
                </Suspense>

                {/*<Stats showPanel={2} className="stats" />*/}
            </ARCanvas>
        </div>
    );
}

export default Scene;
